import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import { formatDateTime } from '../../utils/helpers';
import toast from 'react-hot-toast';

export default function ChatThread({ caseId, currentUser }) {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMessages();
  }, [caseId]);

  const fetchMessages = async () => {
    try {
      const data = await api.messages.list(caseId);
      setMessages(Array.isArray(data) ? data : (data.messages || data.data || []));
    } catch (error) {
      console.error('Failed to fetch messages:', error);
      toast.error('Failed to load messages');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="skeleton" style={{ height: '400px' }}></div>;

  return (
    <div className="chat-thread">
      {messages.length === 0 ? (
        <p className="text-gray">No messages yet</p>
      ) : (
        <div className="messages-list">
          {messages.map((msg) => (
            <div key={msg.id} className={`message ${msg.user_id === currentUser?.id ? 'own' : 'other'}`}>
              <div className="message-content">{msg.message}</div>
              <span className="message-time">{formatDateTime(msg.created_at)}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
